import { Action } from 'redux';

import { ISiteMetadata } from '~src/siteManagement/serverApi/types/ISiteMetadata';

import { isActionFactory } from './isActionFactory';

export const RefreshSiteMetadata = 'RefreshSiteMetadata';

export interface RefreshSiteMetadataAction extends Action {
  metadata: ISiteMetadata | null;
}

export function refreshSiteMetadata(metadata: ISiteMetadata | null): RefreshSiteMetadataAction {
  return {
    type: RefreshSiteMetadata,
    metadata,
  };
}

export const isRefreshSiteMetadataAction =
  isActionFactory<RefreshSiteMetadataAction>(RefreshSiteMetadata);